import { ANALYSES_BASE_ROUTE, TABS } from '@/src/utils/constants'
import { LayoutMain } from '../../layouts/LayoutMain/LayoutMain'
import { AuthRoute } from '../../routes/routes.components'

import React, { Suspense } from 'react'
import { Navigate, type RouteObject } from 'react-router-dom'
const AnalyticsScreenLazy = React.lazy(() => import('./Analytics.screen'))
const AnalyticsOverviewPageLazy = React.lazy(() => import('./AnalyticsOverview.page'))

const AnalyticsBatchOverviewLazy = React.lazy(() => import('./batch/AnalyticsBatchOverview.page'))
const AnalyticsBatchDetailsLazy = React.lazy(() => import('./batch/AnalyticsBatchDetails.page'))
const AnalyticsBatchStepDetailsLazy = React.lazy(() => import('./batch/AnalyticsBatchStepDetails.page'))

const AnalyticsBaselineDetailsLazy = React.lazy(() => import('./baseline/AnalyticsBaselineDetails.page'))
const AnalyticsBaselineOverviewLazy = React.lazy(() => import('./baseline/AnalyticsBaselineOverview.page'))

const AnalyticsRegressionDetailsLazy = React.lazy(() => import('./multilinear-regression/AnalyticsMultilinearRegressionDetails.page'))
const AnalyticsRegressionOverviewLazy = React.lazy(() => import('./multilinear-regression/AnalyticsRegressionOverview.page'))

const AnalyticsVisualizationDetailsLazy = React.lazy(() => import('./visualization/AnalyticsVisualizationDetails.page'))
const AnalyticsVisualizationOverviewLazy = React.lazy(() => import('./visualization/AnalyticsVisualizationOverview.page'))

const AnalyticsComparisonDetailsLazy = React.lazy(() => import('./comparison/AnalyticsComparisonDetails.page'))
const AnalyticsComparisonOverviewLazy = React.lazy(() => import('./comparison/AnalyticsComparisonOverview.page'))
const AnalyticsLoadProfileLazy = React.lazy(() => import('./load-profile-details/LoadProfileDetailsInsights.screen'))
const AnalyticsLocationsOverviewLazy = React.lazy(() => import('./location-overview/Locations.screen'))
const EnergyInsightPageLazy = React.lazy(() => import('./energy-insights/EnergyInsight.page'))

/** @deprecated Not being used anywhere. Marked for removal 2025-10-31 */
const AnalyticsPage = (
  <Suspense fallback={<div></div>}>
    <AnalyticsScreenLazy />
  </Suspense>
)

const AnalyticsOverviewPage = (
  <Suspense fallback={<div></div>}>
    <AnalyticsOverviewPageLazy />
  </Suspense>
)

const BatchOverviewPage = (
  <Suspense fallback={<div></div>}>
    <AnalyticsBatchOverviewLazy />
  </Suspense>
)

const BaselineOverviewPage = (
  <Suspense fallback={<div></div>}>
    <AnalyticsBaselineOverviewLazy />
  </Suspense>
)

const RegressionOverviewPage = (
  <Suspense fallback={<div></div>}>
    <AnalyticsRegressionOverviewLazy />
  </Suspense>
)

const VisualizationOverviewPage = (
  <Suspense fallback={<div></div>}>
    <AnalyticsVisualizationOverviewLazy />
  </Suspense>
)

const ComparisonOverviewPage = (
  <Suspense fallback={<div></div>}>
    <AnalyticsComparisonOverviewLazy />
  </Suspense>
)

const BatchDetailsPage = (
  <Suspense fallback={<div></div>}>
    <AnalyticsBatchDetailsLazy />
  </Suspense>
)

const BatchStepDetailPage = (
  <Suspense fallback={<div></div>}>
    <AnalyticsBatchStepDetailsLazy />
  </Suspense>
)

const VisualizationDetailsPage = (
  <Suspense fallback={<div></div>}>
    <AnalyticsVisualizationDetailsLazy />
  </Suspense>
)

const BaselineDetailsPage = (
  <Suspense fallback={<div></div>}>
    <AnalyticsBaselineDetailsLazy />
  </Suspense>
)

const RegressionDetailsPage = (
  <Suspense fallback={<div></div>}>
    <AnalyticsRegressionDetailsLazy />
  </Suspense>
)

const ComparisonDetailsPage = (
  <Suspense fallback={<div></div>}>
    <AnalyticsComparisonDetailsLazy />
  </Suspense>
)

const LoadProfileDetailsPage = (
  <Suspense fallback={<div></div>}>
    <AnalyticsLoadProfileLazy />
  </Suspense>
)

const LocationsOverviewPage = (
  <Suspense fallback={<div></div>}>
    <AnalyticsLocationsOverviewLazy />
  </Suspense>
)

const EnergyInsightPage = (
  <Suspense fallback={<div></div>}>
    <EnergyInsightPageLazy />
  </Suspense>
)

export const analyticsRoutesV2: RouteObject[] = [
  {
    path: ANALYSES_BASE_ROUTE,
    element: (
      <AuthRoute>
        <LayoutMain />
      </AuthRoute>
    ),
    children: [
      { path: '', element: <Navigate replace to={TABS.analysis.energyInsights} /> },
      {
        path: TABS.analysis.energyInsights,
        element: AnalyticsOverviewPage,
        children: [{ path: '', element: EnergyInsightPage }],
      },
      {
        path: TABS.analysis.standortvergleich,
        element: AnalyticsOverviewPage,
        children: [{ path: '', element: LocationsOverviewPage }],
      },
      {
        path: TABS.analysis.lastgangdetails,
        element: AnalyticsOverviewPage,
        children: [{ path: '', element: LoadProfileDetailsPage }],
      },
      {
        path: TABS.analysis.comparison,
        element: AnalyticsOverviewPage,
        children: [{ path: '', element: ComparisonOverviewPage }],
      },
      { path: 'comparison/:comparisonId?', element: ComparisonDetailsPage },
      {
        path: TABS.analysis.baseline,
        element: AnalyticsOverviewPage,
        children: [{ path: '', element: BaselineOverviewPage }],
      },
      { path: 'baseline/:baselineId?', element: BaselineDetailsPage },

      {
        path: TABS.analysis.batch,
        element: AnalyticsOverviewPage,
        children: [{ path: '', element: BatchOverviewPage }],
      },

      { path: 'batch/:batchId?', element: BatchDetailsPage },
      { path: 'batch/:batchId/steps/:stepId?', element: BatchStepDetailPage },

      {
        path: TABS.analysis.visualization,
        element: AnalyticsOverviewPage,
        children: [{ path: '', element: VisualizationOverviewPage }],
      },
      { path: 'visualization/:visualizationId?', element: VisualizationDetailsPage },

      {
        path: TABS.analysis.regression,
        element: AnalyticsOverviewPage,
        children: [{ path: '', element: RegressionOverviewPage }],
      },
      { path: 'regression/:regressionId?', element: RegressionDetailsPage },

      {
        path: 'comparison',
        element: AnalyticsOverviewPage,
        children: [{ path: '', element: ComparisonOverviewPage }],
      },
      { path: 'comparison/:comparisonId?', element: ComparisonDetailsPage },
    ],
  },
]
